import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsReceivedPayload extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_RECEIVED;
    id: string;
    attributes: {
      aggregate: {
        received_requests: InsightMetric;
      };
    };
  };
}

export const parseRequestsReceivedPayload = (
  payload: BaseInsightPayload
): RequestsReceivedPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_RECEIVED,
    data.attributes,
    false,
    true,
    ['received_requests']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { received_requests: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_RECEIVED,
      id: data.id,
      attributes: {
        aggregate: {
          received_requests: typedAttributes.aggregate.received_requests,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
